// User role enums - matches backend/Prisma schema
export enum UserRole {
  USER = 'USER',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

export enum OrganizationRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

// Re-export for convenience
export { UserRole as GlobalRole };
